<script type="text/jsx">
import ErrorMsg from 'src/common/inputs/ErrorMsg'
import { handlerUseStateVmodel } from 'src/common/mixins/handlerUseStateVmodel'
import moment from 'moment'
import { getFirstHour } from 'src/utils'

const SUPORTED_COMPONENTS = [
  'PTextField', 'PSelect', 'PDatePicker'
]

export default {
  name: 'Validate',
  mixins: [handlerUseStateVmodel(false)],
  components: {ErrorMsg},
  inject: ['registradorDeValidador', 'atualizadorDeValorDoValidador', 'desregistradorDeValidador'],
  props: {
    required: {type: Boolean, 'default': true},
    min: {type: Number, 'default': null},
    max: {type: Number, 'default': null},
    minLength: {type: Number, 'default': null},
    maxLength: {type: Number, 'default': null},
    minDate: {type: Date, 'default': null},
    maxDate: {type: Date, 'default': null},
    customError: {type: String, 'default': ''},
    onlyNumbers: {type: Boolean, 'default': false}
  },
  data () {
    return {
      touched: false,
      componentType: null
    }
  },
  computed: {
    valid () {
      return !this.error
    },
    error () {
      return this.requiredError || this.minMaxError || this.lengthError || this.minDateMaxDateError || this.customError || this.onlyNumbersError
    },
    requiredError () {
      if (!this.required) return ''

      if (this.componentType === 'PSelect') {
        return this.state.selected ? '' : 'campo obrigatório'
      }
      return !this.state ? 'campo obrigatório' : ''
    },
    minMaxError () {
      if (this.componentType !== 'PTextField') return ''

      const number = parseFloat(this.state)
      if ((this.min !== null || this.max !== null) && !isNaN(number)) {
        const validMin = this.min !== null ? number >= this.min : true
        const validMax = this.max !== null ? number <= this.max : true

        if (this.min !== null && this.max !== null) {
          return validMin && validMax ? '' : `deve estar entre ${this.min} e ${this.max}`
        } else if (this.max !== null) {
          return validMax ? '' : `deve ser menor ou igual a ${this.max}`
        } else if (this.min !== null) {
          return validMin ? '' : `deve ser maior ou igual a ${this.min}`
        }
      }
      return ''
    },
    minDateMaxDateError () {
      if (this.componentType !== 'PDatePicker' || (!this.minDate && !this.maxDate)) return

      const date = this.state ? getFirstHour(this.state) : null
      const min = this.minDate ? getFirstHour(this.minDate) : null
      const max = this.maxDate ? getFirstHour(this.maxDate) : null

      if (min && date && moment(date).isBefore(min)) {
        return `deve ser após ${moment(min).format('DD/MM/YYYY')}`
      } else if (max && date && moment(this.state).isAfter(max)) {
        return `deve ser antes de ${moment(max).format('DD/MM/YYYY')}`
      }
      return ''
    },
    lengthError () {
      if (this.componentType !== 'PTextField' || (!this.required && !this.state)) return ''

      const text = this.state

      if (this.maxLength !== null && text && text.length > this.maxLength) {
        return `deve ter no máximo ${this.maxLength} caracteres`
      } else if (this.minLength !== null && (!text || text.length < this.minLength)) {
        return `deve ter no mínimo ${this.minLength} caracteres`
      }
      return ''
    },
    onlyNumbersError () {
      if (this.componentType !== 'PTextField' || !this.onlyNumbers) return ''

      const inputText = this.state
      const regex = /\D/g
      if (regex.test(inputText)) {
        return 'apenas números'
      }
      return ''
    }
  },
  methods: {
    setTouch (value) {
      this.touched = value
    }
  },
  beforeMount () {
    if (this.componentType === null) {
      this.componentType = this.$slots.default[0].componentOptions.Ctor.options.name

      if (!SUPORTED_COMPONENTS.includes(this.componentType)) {
        throw new Error(`Validate component dont suport ${this.componentType} components`)
      }
    }
  },
  mounted () {
    const idDesteComponente = this._uid
    this.registradorDeValidador(idDesteComponente)
    this.atualizadorDeValorDoValidador(idDesteComponente, this.valid)
  },
  beforeDestroy () {
    const idDesteComponente = this._uid
    this.desregistradorDeValidador(idDesteComponente)
  },
  watch: {
    valid (novoValor, valorAntigo) {
      if (novoValor === valorAntigo) return
      const idDesteComponente = this._uid
      console.log('watch', idDesteComponente, novoValor)
      this.atualizadorDeValorDoValidador(idDesteComponente, novoValor)
    }
  },
  render (h) {
    const slotDefault = this.$slots.default

    // validations if the component in slot is valid

    if (slotDefault.length !== 1) {
      throw new Error('Invalid slot. This component only support one slot with only one element')
    }

    if (!slotDefault[0].elm && (
      slotDefault[0].componentOptions.propsData?.useState ||
      slotDefault[0].componentOptions.propsData?.value ||
      slotDefault[0].componentOptions.propsData?.customVmodel)) {
      throw new Error('The Validation component is the one that you must pass the useState, vmodel or customvmodel')
    }

    // this block basically create a v-model to the wrapped component

    slotDefault[0].componentOptions.propsData.customVmodel = {
      set: (value) => {
        this.setTouch(['PTextField', 'PDatePicker'].includes(this.componentType))
        this.state = value
      },
      get: () => {
        return this.state
      }
    }

    return (
      <span class="validate" {...{'class': {error: this.touched ? this.error : ''}}}>
        {slotDefault}
        <error-msg {...{props: {error: this.touched ? this.error : '', keep: true}}}/>
      </span>
    )
  }
}
</script>

<style lang="scss">
.validate {
  // hide all styles
  >.error-msg {
    display: block !important;
  }

  .error-msg {
    display: none;
  }

  &.error {
    input, .multiselect__tags {
      border-bottom-color: var(--color-danger) !important;
    }
    .p-textfield__title-text, .multiselect__placeholder {
      color: var(--color-danger) !important;
    }
  }
}
</style>
